import React from 'react';
import styled, { keyframes } from 'styled-components';

import theme from '@styled/Theme';

const loaderPulse = keyframes`
  {
     0% {
         left: -100%;
     }
     49% {
         left: 100%;
     }
     50% {
         left: 100%;
     }
     100% {
         left: -100%;
     }
 }
`;

const LoaderOuter = styled.div`
  height: 2px;
  width: 100%;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
`;

const LoaderInner = styled.div`
  height: 5px;
  width: 100%;
  position: absolute;

  background-color: ${props => props.color};
  animation-name: ${loaderPulse};
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
`;

export default function Loader({ color }) {
  return (
    <LoaderOuter>
      <LoaderInner color={color} />
    </LoaderOuter>
  );
}

Loader.defaultProps = {
  color: theme.enigmaBlue,
};
